import { connect } from "react-redux";

import App from "../../components/App/App";
import { checkIsLogged, getSouscription } from "../../actions/user";
import { getCases } from "../../actions/cases";

const mapStateToProps = (state) => ({
	listCases: state.planDemand.listCases,
	listCareManager: state.planDemand.listCareManager,
	session: state.user.session,
	redirection: state.user.redirection,
	errorApiMessage: state.apiFlag.errorApiMessage,
});

const mapDispatchToProps = (dispatch) => ({
	checkIsLogged: () => {dispatch(checkIsLogged());},
	getCases: () => {dispatch(getCases());},
	getSouscription: () => {dispatch(getSouscription());}
});

export default connect(mapStateToProps, mapDispatchToProps)(App);